import {SET_ME} from "./constants";
import {SetMeActions, SetMeState} from "./types";

const initialState: SetMeState = {
  me: undefined,
  mePrevious: undefined,
}

const reducer = (
  state = initialState,
  action: SetMeActions,
): SetMeState => {
  switch (action.type) {
    case SET_ME:
      return {
        me: action.payload,
        mePrevious: state.me,
      };
    default:
      return state;
  }
}

export default reducer;
